export const sed = {
  id: 5,
  name: "Socio-Economic Development",
  slug: "sed",
  status: "on track",
  description: "Contributions to socio-economic development beneficiaries and community projects",
  deadline: "31 Jan 2026",
  current_points: 4.2,
  total_points: 5,
  target: 5,
  workflow_completed: 5,
  workflow_total: 6,
  icon: "fas fa-heart",
  theme: { gradientFrom: "#f43f5e", gradientTo: "#ef4444" },
  steps: [
    {
      id: "sed-1",
      title: "Identify SED Beneficiaries",
      description:
        "Select qualifying beneficiaries (75% black, unemployed, disabled, or rural communities)",
      status: "completed",
      due: "05 Jan 2026",
      owner_initials: "NK",
      owner_name: "Nomvula Khumalo",
      owner_role: "CSI Manager",
      owner_email: "nomvula.khumalo@company.co.za",
      owner_number: "+27 88 789 0123",
      owner_role_desc: "Manages corporate social responsibility initiatives",
      required_documents: ["Beneficiary Selection Criteria", "Beneficiary List"],
    },
    {
      id: "sed-2",
      title: "Verify NPO/PBO Status",
      description:
        "Confirm registration status and collect certificates from beneficiary organisations",
      status: "completed",
      due: "08 Jan 2026",
      owner_initials: "NK",
      owner_name: "Nomvula Khumalo",
      owner_role: "CSI Manager",
      owner_email: "nomvula.khumalo@company.co.za",
      owner_number: "+27 88 789 0123",
      owner_role_desc: "Manages corporate social responsibility initiatives",
      required_documents: ["NPO Certificates", "PBO Tax Exemption Letters"],
    },
    {
      id: "sed-3",
      title: "Execute SED Contributions",
      description:
        "Disburse approved SED contributions to beneficiaries",
      status: "completed",
      due: "12 Jan 2026",
      owner_initials: "FN",
      owner_name: "Finance Team",
      owner_role: "Finance",
      required_documents: ["Proof of Payment"],
    },
    {
      id: "sed-4",
      title: "Collect Impact Evidence",
      description:
        "Collect beneficiary confirmation letters and impact reports",
      status: "completed",
      due: "18 Jan 2026",
      owner_initials: "NK",
      owner_name: "Nomvula Khumalo",
      owner_role: "CSI Manager",
      required_documents: ["Impact Reports", "Beneficiary Letters"],
    },
    {
      id: "sed-5",
      title: "Prepare SED Summary",
      description:
        "Prepare SED contribution summary and points calculation",
      status: "completed",
      due: "25 Jan 2026",
      owner_initials: "LZ",
      owner_name: "Lindiwe Zulu",
      owner_role: "BEE Consultant",
      required_documents: ["SED Summary Report"],
    },
    {
      id: "sed-6",
      title: "Submit SED Pack",
      description:
        "Submit complete SED evidence pack for verification",
      status: "pending",
      due: "31 Jan 2026",
      owner_initials: "JD",
      owner_name: "John Dlamini",
      owner_role: "BEE Manager",
      required_documents: ["Complete SED Pack"],
    },
  ],
};
